import {
  POSITION_SLOT_STATUS,
  POSITION_SLOT_WORKER_TYPE,
  POSITION_SLOT_WORKER_TYPE_LABELS,
  POSITION_SLOTS_PATH,
} from 'domain/shared/positionSlot';
import type { PositionSlotWorkerType } from 'domain/shared/positionSlot';

export { POSITION_SLOTS_PATH, POSITION_SLOT_STATUS, POSITION_SLOT_WORKER_TYPE, POSITION_SLOT_WORKER_TYPE_LABELS };
export type { PositionSlotWorkerType };

export const POSITION_SLOT_WORKER_TYPE_CREATE_LABELS: Dictionary<string> = {
  [POSITION_SLOT_WORKER_TYPE.STAFF]: 'Staff',
  [POSITION_SLOT_WORKER_TYPE.CONTRACTOR]: 'Contractor',
};

export const POSITION_SLOT_WORKER_TYPE_EXCEPTION_TOOLTIP =
  'Legacy position for a worker who has a B2B or CFS contract, but employee worker type.';

export const POSITION_SLOT_STATUS_LABELS: Dictionary<string> = {
  [POSITION_SLOT_STATUS.PENDING]: 'Pending',
  [POSITION_SLOT_STATUS.OPEN]: 'Open',
  [POSITION_SLOT_STATUS.FILLED]: 'Filled',
  [POSITION_SLOT_STATUS.ARCHIVED]: 'Archived',
};

export const DEFAULT_POSITION_SLOT_STATUS_FILTER = [
  POSITION_SLOT_STATUS.PENDING,
  POSITION_SLOT_STATUS.OPEN,
  POSITION_SLOT_STATUS.FILLED,
];

export const POSITION_SLOT_LIST_READ = 'PEOPLE_MANAGEMENT_POSITION_SLOT_LIST_READ_LIST';
export const POSITION_SLOT_CREATE = 'PEOPLE_MANAGEMENT_POSITION_SLOT_CREATE';
export const POSITION_SLOT_ASSIGN = 'PEOPLE_MANAGEMENT_POSITION_SLOT_ASSIGN';
export const POSITION_SLOT_ARCHIVE = 'PEOPLE_MANAGEMENT_POSITION_SLOT_ARCHIVE';
export const POSITION_SLOT_UPDATE = 'PEOPLE_MANAGEMENT_POSITION_SLOT_UPDATE';
export const POSITION_SLOT_CONFIRM = 'PEOPLE_MANAGEMENT_POSITION_SLOT_CONFIRM_ASSIGNMENT';
export const POSITION_SLOT_EMPLOYEE_VALIDATION = 'PEOPLE_MANAGEMENT_CONTRACT_LIST_VALIDATE_POSITION_SLOTS';
